import React from "react"
import { Button, FormControl } from "react-bootstrap"
import FontAwesome from "react-fontawesome"
import { debounce } from "../../../lib/debounce"
import { glAccountsDataWithFineractId } from "../../../lib/utils"

export default class TransactionSeachPanel extends React.Component {

  constructor(props) {

    super(props)
    const { query: { fromDate, toDate, glAccountId, transactionId } } = this.props

    this.state = {
      showFilter: true,
      glAccountId: glAccountId ? glAccountId : '',
      transactionId: transactionId ? transactionId : '',
      fromDate: fromDate ? fromDate : '',
      toDate: toDate ? toDate : '',
    }

    this.debounceSearh = debounce(this.searchTransactionId, 1000)
  }

  toggleFiler = () => this.setState({ showFilter: !this.state.showFilter })

  glAccountIdChanged = glAccountId => {
    this.setState({ glAccountId })
    this.props.filterChanged('glAccountId', glAccountId)
  }

  transactionIdChanged = transactionId => {
    this.setState({ transactionId })
    this.debounceSearh(transactionId)
  }

  searchTransactionId = transactionId => {
    this.props.filterChanged('transactionId', transactionId.trim())
  }

  fromDateChanged = fromDate => {
    this.setState({ fromDate })
    this.props.filterChanged('fromDate', fromDate)
  }

  toDateChanged = toDate => {
    this.setState({ toDate })
    this.props.filterChanged('toDate', toDate)
  }

  runClearFilters = () => {
    this.setState({
      glAccountId: '',
      transactionId: '',
      fromDate: '',
      toDate: '',
    })
    this.props.doClearFilters()
  }

  renderForm = () => {

    const { glAccountId, transactionId, fromDate, toDate } = this.state,
    { glAccounts } = this.props,
    glAccountsData = glAccountsDataWithFineractId(glAccounts)

    return (
      <div className="flex gap-8 items-center flex-wrap">

        <div className="w-full sm:w-60">
          <label>Select an account</label>
          <FormControl id='glAccountId' componentClass="select" 
            placeholder="Select an account"
            value={ glAccountId }
            onChange={e => this.glAccountIdChanged(e.target.value)}>

            <option value=''>Choose account</option>
            { glAccountsData.map((option, index) =>
              <option key={ index } value={ option.value }>
                { option.title }
              </option>)
            }
          </FormControl>
        </div>

        <div className="w-full sm:w-60">
          <label>Transaction ID</label>
          <FormControl type="text" id='transactionId'
            value={ transactionId } placeholder="Transaction ID"
            onChange={e => this.transactionIdChanged(e.target.value)}
          />
        </div>

        <div className="w-full sm:w-auto overflow-auto">
          <label>Date range</label>
          <div className="flex gap-8 items-center">

            <FormControl type="date"
              value={ fromDate } placeholder="From date"
              onChange={e => this.fromDateChanged(e.target.value)}
            />

            <FormControl type="date"
              value={ toDate } placeholder="To date"
              onChange={e => this.toDateChanged(e.target.value)}
            />
          </div>
        </div>
      </div>
    )
  }

  render() {

    const { showFilter } = this.state
    return (
      <div className="border rounded-10 p-10 mb-10">

        <div className="flex justify-between items-center gap-10">

          <span className="uppercase text-xs">Add filters</span>

          <div className="flex item-center gap-1 sm:gap-2.5">
            <Button bsStyle="default" onClick={ this.runClearFilters } className="font-size-13"
              title="Clear all filters">
              CLEAR FILTERS
            </Button>

            <Button title="Show/hide filters" onClick={ this.toggleFiler }>
              <FontAwesome name={ showFilter ? 'chevron-up' : 'chevron-down '} />
            </Button>
          </div>
        </div>

        { showFilter && this.renderForm() }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Accounting/JournalEntries/TransactionSeachPanel.js